'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _baidu = require('./baidu');

var _baidu2 = _interopRequireDefault(_baidu);

var _google = require('./google');

var _google2 = _interopRequireDefault(_google);

var _piwik = require('./piwik');

var _piwik2 = _interopRequireDefault(_piwik);

var _channel = require('./channel');

var _channel2 = _interopRequireDefault(_channel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    init: function init(params) {
        // 如果是服务端渲染，则不走统计的逻辑
        if (params.isServer) {
            return;
        }
        if (typeof params.load === 'function' && !params.load()) {
            return;
        }
        if (params.load === false) {
            return;
        }

        _baidu2.default.init(params.baidu, params.router);
        _google2.default.init(params.google);
        _piwik2.default.init(params.piwik, params.router);
        _channel2.default.init();
    },
    doStatistics: function doStatistics() {
        _channel2.default.doStatistics();
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/statistics/dist/index.js
// module id = 14jf
// module chunks = 11